/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { CycloneAndScrubber } from "./modelCycloneAndScrubber";

class ControllerCycloneAndScrubber extends ControllerModel {
  constructor() {
    super("ControllerCycloneAndScrubber");
    
    this.setNewNode = (callback) => {
      let cycloneAndScrubber = new CycloneAndScrubber();
      cycloneAndScrubber.decorate(callback);

      this.addNode(cycloneAndScrubber);
    }

    this.loadNode = (node, callback) => {
      let cycloneAndScrubber = new CycloneAndScrubber();
      cycloneAndScrubber.copyFrom(node);
      cycloneAndScrubber.decorate(callback);
      this.addNode(cycloneAndScrubber)
    }

    this.getProperties = async (node) => {
      let n = new CycloneAndScrubber();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new CycloneAndScrubber();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerCycloneAndScrubber };
